var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('clipper-upload',{staticClass:"upload",model:{value:(_vm.src),callback:function ($$v) {_vm.src=$$v},expression:"src"}},[_vm._v("upload")]),_vm._v("\n    "+_vm._s(_vm.src)+"\n    "),_c('clipper-basic',{attrs:{"name":"basic"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }